import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
  Stack,
  Divider,
} from "@mui/material";
import { AuctionServices } from "../../services/AllServices";
import { Loader } from "../../components/CustomLoader";
import errorHandler from "../../utils/errorHandler";
import { capitalize } from "../../utils/helpers";
import { useEffect, useState } from "react";

const ViewTicket = ({ id, show, onHide }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const userData = async () => {
    try {
      setLoading(true);
      const response = await AuctionServices.getById({ id: id });
      setData(response.data.data);
    } catch (error) {
      errorHandler(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    userData();
  }, []);

  return (
    <Dialog maxWidth="md" fullWidth open={show} onClose={onHide}>
      <DialogTitle>Auction Details:</DialogTitle>
      {loading ? (
        <Loader />
      ) : (
        <DialogContent dividers>
          <Stack spacing={1}>
            {/* Auction Details Section */}
            <Box>
              <Typography variant="subtitle1">Start Date:</Typography>
              <DialogContentText>
                {new Date(data?.startDate).toLocaleString()}
              </DialogContentText>

              <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
                End Date:
              </Typography>
              <DialogContentText>
                {new Date(data?.endDate).toLocaleString()}
              </DialogContentText>

              <Typography variant="subtitle1" sx={{ marginTop: 2 }}>
                Auction Status:
              </Typography>
              <DialogContentText>{capitalize(data?.auctionStatus)}</DialogContentText>
            </Box>

            {/* Ticket Details Section */}
            {data?.ticket?.length > 0 && (
              <Box>
                 <Divider sx={{ marginBottom: 1 }} />
                <Typography variant="h6" gutterBottom>
                  Ticket Details:
                </Typography>
               
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px", // Gap between subcategory cards
                    marginTop: 0,
                  }}
                  >
                {data.ticket.map((ticket) => (
                  <DialogContentText key={ticket._id} sx={{ marginTop: 1 }}>
                    {capitalize(ticket.name)}
                  </DialogContentText>
                ))}
                </Box>
              </Box>
            )}

            {/* Category Details Section */}
            {data?.category?.length > 0 && (
              <Box>
                 <Divider sx={{ marginBottom: 2 }} />
                <Typography variant="h6" gutterBottom>
                  Category:
                </Typography>
               
                {data.category.map((cat) => (
                  <DialogContentText key={cat._id} sx={{ marginTop: 1 }}>
                    {capitalize(cat.name)}
                  </DialogContentText>
                ))}
              </Box>
            )}

            {/* Subcategories Section */}
            {data?.subcategories?.length > 0 && (
              <Box>
                 <Divider sx={{ marginBottom: 1 }} />

                <Typography variant="h6" gutterBottom>
                Available Subcategories:
                </Typography>
               
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px", // Gap between subcategory cards
                    marginTop: 2,
                  }}
                >
                  {data.subcategories.map((subcategory) => (
                    <Box
                      key={subcategory._id}
                      sx={{
                        flex: "1 1 calc(33.333% - 20px)", 
                      }}
                    >
                      {/* <Typography variant="subtitle1">Name:</Typography> */}
                      <DialogContentText>
                        {capitalize(subcategory.name)}
                      </DialogContentText>

                      {/* <Typography variant="subtitle1" sx={{ marginTop: 1 }}>
            Status:
          </Typography>
          <DialogContentText>{capitalize(subcategory.status)}</DialogContentText> */}
                    </Box>
                  ))}
                </Box>
              </Box>
            )}
          </Stack>
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="outlined" onClick={onHide}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewTicket;
